import { get } from 'lodash';
import { DEFAULT_POST_PAGE_FONT_SIZE_MOBILE, DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE, DEFAULT_POST_HEADER_THREE_SIZE_MOBILE, DEFAULT_POST_QUOTES_SIZE_MOBILE, } from '../../../constants/post-page';
import { POST_TEXT_COLOR, LINK_AND_HASHTAG_COLOR, CARD_BACKGROUND_COLOR, BUTTON_COLOR, POST_PAGE_FONT_PATH, POST_PAGE_FONT_SIZE_MOBILE_PATH, POST_HEADER_TWO_FONT_SIZE_MOBILE_PATH, POST_HEADER_THREE_FONT_SIZE_MOBILE_PATH, POST_QUOTES_FONT_SIZE_MOBILE_PATH, POST_HEADER_FOUR_FONT_SIZE_MOBILE_PATH, POST_HEADER_FIVE_FONT_SIZE_MOBILE_PATH, POST_HEADER_SIX_FONT_SIZE_MOBILE_PATH, POST_HEADER_TWO_FONT, POST_HEADER_THREE_FONT, POST_HEADER_FOUR_FONT, POST_HEADER_FIVE_FONT, POST_HEADER_SIX_FONT, } from '../../../constants/wix-params';
import { getSiteColor, setColorOpacity } from '../../../services/colors';
export function getMobileStyles(appSettings) {
    const mobileFontSize = get(appSettings, POST_PAGE_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_PAGE_FONT_SIZE_MOBILE);
    const mobileHeaderTwoFontSize = get(appSettings, POST_HEADER_TWO_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE);
    const mobileHeaderThreeFontSize = get(appSettings, POST_HEADER_THREE_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_HEADER_THREE_SIZE_MOBILE);
    const mobileHeaderFourFontSize = get(appSettings, POST_HEADER_FOUR_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_HEADER_THREE_SIZE_MOBILE);
    const mobileHeaderFiveFontSize = get(appSettings, POST_HEADER_FIVE_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_HEADER_THREE_SIZE_MOBILE);
    const mobileHeaderSixFontSize = get(appSettings, POST_HEADER_SIX_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_HEADER_THREE_SIZE_MOBILE);
    const mobileQuotesFontSize = get(appSettings, POST_QUOTES_FONT_SIZE_MOBILE_PATH, DEFAULT_POST_QUOTES_SIZE_MOBILE);
    return {
        mobileFontSize,
        mobileHeaderTwoFontSize,
        mobileHeaderThreeFontSize,
        mobileHeaderFourFontSize,
        mobileHeaderFiveFontSize,
        mobileHeaderSixFontSize,
        mobileQuotesFontSize,
    };
}
export function getStyleObject(appSettings) {
    const textColor = getSiteColor(appSettings, {
        wixParam: POST_TEXT_COLOR,
        presetFallback: 'color-5',
        colorFallback: '#000',
    });
    const opaqueBackgroundColor = getSiteColor(appSettings, {
        wixParam: CARD_BACKGROUND_COLOR,
        presetFallback: 'color-1',
        colorFallback: '#fff',
        opacity: 1,
    });
    const dividerColor = setColorOpacity({ color: textColor, alpha: 0.2 });
    const activeDividerColor = setColorOpacity({ color: textColor, alpha: 0.5 });
    const highlightedColor = getSiteColor(appSettings, {
        wixParam: BUTTON_COLOR,
        presetFallback: 'color-8',
        colorFallback: '#3899ec',
        opacity: 1,
    });
    const linkHashtagColor = getSiteColor(appSettings, {
        wixParam: LINK_AND_HASHTAG_COLOR,
        presetFallback: 'color-8',
        colorFallback: '#44C2BC',
    });
    const { mobileFontSize, mobileHeaderTwoFontSize, mobileHeaderThreeFontSize, mobileQuotesFontSize, mobileHeaderFourFontSize, mobileHeaderFiveFontSize, mobileHeaderSixFontSize, } = getMobileStyles(appSettings);
    const textFontSize = get(appSettings, POST_PAGE_FONT_PATH, {
        size: 18,
    }).size;
    const { size: headerTwoFontSize } = get(appSettings, POST_HEADER_TWO_FONT, {
        size: Math.min(textFontSize + 10, 38),
    });
    const { size: headerThreeFontSize } = get(appSettings, POST_HEADER_THREE_FONT, { size: Math.min(textFontSize + 4, 32) }); // prettier-ignore
    const { size: headerFourFontSize } = get(appSettings, POST_HEADER_FOUR_FONT, { size: Math.min(textFontSize + 2, 30) }); // prettier-ignore
    const { size: headerFiveFontSize } = get(appSettings, POST_HEADER_FIVE_FONT, {
        size: Math.min(textFontSize, 28),
    });
    const { size: headerSixFontSize } = get(appSettings, POST_HEADER_SIX_FONT, {
        size: Math.min(textFontSize - 2, 24),
    });
    return {
        textColor,
        opaqueBackgroundColor,
        dividerColor,
        activeDividerColor,
        highlightedColor,
        linkHashtagColor,
        mobileFontSize,
        headerTwoFontSize,
        headerThreeFontSize,
        headerFourFontSize,
        headerFiveFontSize,
        headerSixFontSize,
        mobileHeaderTwoFontSize,
        mobileHeaderThreeFontSize,
        mobileHeaderFourFontSize,
        mobileHeaderFiveFontSize,
        mobileHeaderSixFontSize,
        mobileQuotesFontSize,
    };
}
export default function getStyle(appSettings) {
    const styleObj = getStyleObject(appSettings);
    const { textColor, opaqueBackgroundColor, dividerColor, activeDividerColor, highlightedColor, linkHashtagColor, mobileFontSize, headerTwoFontSize, headerThreeFontSize, headerFourFontSize, headerFiveFontSize, headerSixFontSize, mobileHeaderTwoFontSize, mobileHeaderThreeFontSize, mobileHeaderFourFontSize, mobileHeaderFiveFontSize, mobileHeaderSixFontSize, mobileQuotesFontSize, } = styleObj;
    return {
        '--rce-text-color': textColor,
        '--rce-opaque-background-color': opaqueBackgroundColor,
        '--rce-divider-color': dividerColor,
        '--rce-active-divider-color': activeDividerColor,
        '--rce-highlighted-color': highlightedColor,
        '--rce-link-hashtag-color': linkHashtagColor,
        '--rce-mobile-font-size': `${mobileFontSize}px`,
        '--rce-header-two-font-size': `${headerTwoFontSize}px`,
        '--rce-header-three-font-size': `${headerThreeFontSize}px`,
        '--rce-header-four-font-size': `${headerFourFontSize}px`,
        '--rce-header-five-font-size': `${headerFiveFontSize}px`,
        '--rce-header-six-font-size': `${headerSixFontSize}px`,
        '--rce-mobile-header-two-font-size': `${mobileHeaderTwoFontSize}px`,
        '--rce-mobile-header-three-font-size': `${mobileHeaderThreeFontSize}px`,
        '--rce-mobile-header-four-font-size': `${mobileHeaderFourFontSize}px`,
        '--rce-mobile-header-five-font-size': `${mobileHeaderFiveFontSize}px`,
        '--rce-mobile-header-six-font-size': `${mobileHeaderSixFontSize}px`,
        '--rce-mobile-quotes-font-size': `${mobileQuotesFontSize}px`,
    };
}
//# sourceMappingURL=get-style.js.map